export function transformAdjustUrl(url: string, name: string): string {
  const isPixel = ['click_audit_pixel', 'pixel', 'pixel_additional', 'pixel_additional2'].includes(name);
  const isLink = name === 'link';
  
  // Если не Adjust или не link/pixel поле - возвращаем как есть
  if (!url.includes('view.adjust.com') || (!isLink && !isPixel)) {
    return url;
  }
  
  // Для link поля - без изменений
  if (isLink) {
    return url;
  }
  
  // Для pixel поля - без изменений
  // (можно добавить проверку /impression если нужно строже)
  // if (isPixel && !url.includes('/impression')) {
  //   return url; // Не pixel аудита
  // }
  
  return url;
}